module.exports = __webpack_public_path__ + "img/img_T6.7.78f7262c.png";